// ── Smooth inertial scroll ────────────────────────────────────
// Intercepte la molette et applique un ease sur window.scrollY.
// Compatible avec les animations scroll (revealObserver, section-nav…).
// Désactivé si prefers-reduced-motion.
(function() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    // Désactive sur mobile / touch (scroll natif déjà fluide)
    if ("ontouchstart" in window) return;
    let current = window.scrollY;
    let target = window.scrollY;
    let rafId = null;
    const EASE = 0.1; // 0.05 = très doux, 0.15 = plus réactif
    // Intercepte la molette → accumule dans target
    // Ignore si on scroll dans un conteneur scrollable (ex: panel projet)
    window.addEventListener("wheel", (e)=>{
        const panel = document.getElementById("project-panel");
        if (panel && panel.classList.contains("open") && panel.contains(e.target)) return;
        e.preventDefault();
        // Resync si un scrollTo() natif externe a déplacé la page (ex: bouton "retour en haut")
        if (Math.abs(current - window.scrollY) > 10) {
            current = window.scrollY;
            target = window.scrollY;
        }
        target += e.deltaY * 1.0;
        target = Math.max(0, Math.min(target, document.body.scrollHeight - window.innerHeight));
        if (!rafId) loop();
    }, {
        passive: false
    });
    function loop() {
        const diff = target - current;
        if (Math.abs(diff) < 0.5) {
            current = target;
            window.scrollTo(0, current);
            rafId = null;
            return;
        }
        current += diff * EASE;
        window.scrollTo(0, current);
        rafId = requestAnimationFrame(loop);
    }
})();

//# sourceMappingURL=index.6f096ca4.js.map
